import { useRouterQuery } from '~hooks/useRouterQuery';

import { MENU_TYPE } from '../constants';

export function useGetMenuByParams() {
  return useRouterQuery('selectedMenu') as MENU_TYPE;
}
